import { Container } from "@mui/material";
import { graphql } from "babel-plugin-relay/macro";
import { useFragment, useLazyLoadQuery } from "react-relay";
import { AppClipNotificationsQuery } from "./__generated__/AppClipNotificationsQuery.graphql";
import { AppClipNotifications_brand$key } from "./__generated__/AppClipNotifications_brand.graphql";
import useAppClipNotificationsUpdateMutation from "../../../../mutations/useAppClipNotificationsUpdateMutation";
import AutomatedNotificationsForm from "../automation/notifications/AutomatedNotificationsForm";
import AppClipLinkGenerator from "./AppClipLinkGenerator";

const query = graphql`
  query AppClipNotificationsQuery($id: ID!) {
    brand(id: $id) {
      ...AppClipNotifications_brand
    }
  }
`;

const brandFragment = graphql`
  fragment AppClipNotifications_brand on BrandType {
    appConfig {
      id
      appClipAutomatedNotifications {
        ...AutomatedNotificationsForm_automatedNotifications
      }
    }
    ...AppClipLinkGenerator_brand
  }
`;

const AppClipNotifications = ({ brandID }: { brandID: string }) => {
  const data = useLazyLoadQuery<AppClipNotificationsQuery>(query, {
    id: brandID,
  });
  const brand = useFragment<AppClipNotifications_brand$key>(
    brandFragment,
    data.brand
  );

  const [
    saveAppClipNotificationsMutation,
    isAppClipNotificationsMutationInFlight,
  ] = useAppClipNotificationsUpdateMutation();

  return (
    <Container maxWidth="md">
      <AppClipLinkGenerator brand={brand} />
      <AutomatedNotificationsForm
        isAppClip={true}
        appConfigId={brand.appConfig.id}
        automatedNotifications={brand.appConfig.appClipAutomatedNotifications}
        handleSave={(automatedNotifications, onCompleted) => {
          saveAppClipNotificationsMutation(
            {
              appConfigId: brand.appConfig.id,
              notifications: automatedNotifications,
            },
            onCompleted
          );
        }}
        isSaving={isAppClipNotificationsMutationInFlight}
      />
    </Container>
  );
};

export default AppClipNotifications;
